<template>
  <div class="intro w-full max-w-7xl mx-auto">
    <!-- filter -->
    <div class="md:flex items-center mb-2 px-4">
      <p class="text-xl font-black mr-2 mb-2 md:mb-0">回數總覽</p>

      <div class="relative m-2">
        <select v-model="selectedLevel" class="block appearance-none w-full border border-gray-400 py-2 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-500" id="filterBtn"
          >
          <option :value="null">初級與中級</option>
          <option value="初級">初級</option>
          <option value="中級">中級</option>
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 textColorDarkBlack">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
          </svg>
        </div>
      </div>

      <div class="relative m-2">
        <select v-model="selectedType" class="block appearance-none w-full border border-gray-400 py-2 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-500" id="filterBtn"
          >
          <!-- <option :value="value" v-for="(value, name) in examList" :key="value">{{ name }}</option> -->
          <option :value="null">口說與寫作</option>
          <option value="speaking">口說</option>
          <option value="writing">寫作</option>
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 textColorDarkBlack">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
          </svg>
        </div>
      </div>
    </div>
    <!-- main -->
    <div v-for="(item, index) in menuData" :key="index" class="flex flex-wrap w-full"
      :class="{ 'hidden': selectedLevel === '初級' && index === '中級' || selectedLevel === '中級' && index === '初級' }">
      <div v-for="(child, idx) in item" :key="idx" class="p-3 lg:p-4 w-full lg:w-1/2" :class="{ 'lg:w-1/4': selectedType !== null }">
        <div class="gept_main_bg10 p-2 lg:p-3 xl:p-4">
          <p class="text-lg xl:text-xl font-bold mb-1">{{ index }} {{ idx }}</p>
          <div class="flex w-full">
            <div class="w-1/2 p-2" v-for="(child2, idx2) in child" :key="idx2" :class="{ 'hidden': selectedType !== null && child2.type !== selectedType, 'w-full': selectedType !== null && child2.type === selectedType }">
              <div class="bg-white rounded-lg overflow-hidden">
                <p class="text-center text-xl font-semibold text-white py-2 mb-2" :class="{ 'gept_main_bg6': child2.type === 'speaking', 'gept_main_bg7': child2.type === 'writing' }">
                  <span v-if="child2.type === 'speaking'">口說練習</span>
                  <span v-if="child2.type === 'writing'">寫作練習</span>
                </p>
                <p class="text-center text-lg font-semibold mb-3">練習次數</p>
                <p class="text-center text-xl font-bold mb-2 border-b-2 pb-4 mx-2 lg:mx-3" :class="{ 'border_main12': child2.type === 'speaking', 'border_main13': child2.type === 'writing' }">{{ child2.times }}</p>
                <p class="text-center font-semibold text-sm">
                  <span v-if="!child2.due_at" class="text-gray-500">尚未開始練習</span>
                  <span v-if="child2.due_at && moment(child2.due_at).isBefore(moment(), 'second')" class="text-gray-500">有效期已過，請重新扣點</span>
                  <span v-if="child2.due_at && moment(child2.due_at).isAfter(moment(), 'second')" class="gept_main_color4">有效時間：{{ moment(child2.due_at).format('YYYY/MM/DD') }}</span>
                </p>
                <div class="flex mt-3 lg:m-0 lg:p-2 text-sm">
                  <!-- 紀錄 -->
                  <a v-if="!child2.record_id" class="inline-block w-1/2 text-center border-2 rounded-lg m-2 py-2 font-semibold" :class="{ 'border_main12 gept_main_color13': child2.type === 'speaking', 'border_main13 gept_main_color14': child2.type === 'writing', 'text-gray-500 border-gray-500': !child2.record_id }">
                    尚無紀錄
                  </a>
                  <router-link v-if="child2.record_id" :to="{ name: 'gept_report_formal', params: { record_id: child2.record_id } }" class="inline-block w-1/2 text-center border-2 rounded-lg m-2 py-2 font-semibold" :class="{ 'border_main12 gept_main_color13': child2.type === 'speaking', 'border_main13 gept_main_color14': child2.type === 'writing', 'text-gray-500 border-gray-500': !child2.record_id }">
                    查看紀錄
                  </router-link>

                  <!-- 練習 -->
                  <a v-if="!child2.due_at || moment(child2.due_at).isBefore(moment(), 'second')" class="inline-block w-1/2 text-center gept_main_color4 border-2 rounded-lg m-2 py-2 border_main2 font-semibold cursor-pointer" @click="startExam(child2, index, idx)">
                    開始練習
                  </a>
                  <a v-if="child2.due_at && moment(child2.due_at).isAfter(moment(), 'second')" @click="startExam(child2, index, idx)" class="inline-block w-1/2 text-center gept_main_color4 border-2 rounded-lg m-2 py-2 border_main2 font-semibold cursor-pointer">
                    進入練習
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import api from '@/api.js'
  import formal_examJs from '@/components/formal_exam.js'
  export default {
    name: 'Overview',
    metaInfo: {
      title: '回數總覽'
    },
    mixins: [
      formal_examJs
    ],
    data () {
      return {
        menuData: [],
        selectedLevel: null,
        selectedType: null,

        pageSize: 40,
        pagination: {
          currentPage: 1,
          length: 1
        }
      }
    },
    computed: {
      ...mapGetters([
        'lang',
        'remainPoints',
        'authorized'
      ])
    },
    watch: {
      'authorized' (newVal, oldVal) {
        if (!oldVal && newVal) {
          this.getData()
          this.getMenu()
        }
      }
    },
    mounted () {
      this.authorized ? this.getData() : null

      this.setSelectVal()
    },
    methods: {
      setSelectVal () {
        let self = this
        if (self.$route.query.level && self.$route.query.type) {
          self.selectedLevel = self.$route.query.level
          self.selectedType = self.$route.query.type

          self.$router.push({ name: 'GEPT_Overview' })
        }
      },

      getData () {
        let self = this
        let path = `/gept/categories/records?page=${self.pagination.currentPage}&pageSize=${self.pageSize}`
        self.$store.dispatch('isLoading', true)

        api.get(path)
        .then((res) => {
          self.menuData = res.data
          self.$store.dispatch('isLoading', false)
        })
        .catch(() => {
          self.$store.dispatch('isLoading', false)
        })
      },
      startExam (item, index, idx) {
        if (item.due_at && moment(item.due_at).isAfter(moment(), 'second')) {
          this.checkAuth(item, index, idx)
          return
        }

        this.preCheckPoint(item, index, idx)
      },

      goToExam (item, recordId) {
        this.$router.push({ name: 'formal_exam', params: { select_id: item.id, practice_type: item.type }, query: { record_id: recordId } })
      },

      async checkAuth (item, index, idx) {
        let self = this
        try {
          self.$store.dispatch('isLoading', true)
          let result = await self.post_records_purchase(item.id, item.type)
          self.$store.dispatch('isLoading', false)
          if (result && result.record_id) {
            self.goToExam(item, result.record_id)
            return
          }

          self.preCheckPoint(item, index, idx, result)
        } catch {
          self.$store.dispatch('isLoading', false)
          self.rejectAlert()
        }
      },

      async preCheckPoint (item, index, idx, purchaseInfo = null) {
        let self = this
        try {
          self.$store.dispatch('isLoading', true)
          await self.$store.dispatch('getRemainPoints')
          let result = purchaseInfo || await self.post_records_purchase(item.id, item.type)
          let points = self.getPurchasePoints(result)

          self.$store.dispatch('isLoading', false)

          if (result && result.record_id) {
            self.goToExam(item, result.record_id)
            return
          }

          if (points !== null && self.remainPoints >= points) {
            self.confirmPurchase(item, index, idx, points)
            return
          }

          self.rejectAlert()
        } catch {
          self.$store.dispatch('isLoading', false)
          self.rejectAlert()
        }
      },

      getPurchasePoints (purchaseInfo = {}) {
        if (!purchaseInfo) return null
        if (!Object.prototype.hasOwnProperty.call(purchaseInfo, 'points')) return null

        let points = Number(purchaseInfo.points)
        return Number.isFinite(points) ? points : null
      },

      async confirmPurchase (item, level, index, point) {
        let self = this

        let type = item.type === 'writing' ? '寫作練習' : '口說練習'
        let html = `<p class="text-lg text-black mb-3 font-semibold">請問是否要開始</p>
          <p class="text-xl gept_main_color4 mb-3 font-semibold">GEPT ${level} ${index}<span class=" rounded-lg p-1 ml-2 gept_main_bg6 text-white text-lg">${type}</span></p>
          <p class="text-lg text-black mb-1 font-semibold">按下確認後，將扣除${point}點，每次扣點可使用7天。</p>
          <p class="text-lg text-black mb-5 font-semibold">本次扣除可使用至<span class="gept_main_color4">${moment().add(7, 'days').endOf("day").format("YYYY-MM-DD")}</span></p>
          <div class="gept_main_bg11 text-lg p-3 max-w-sm mx-auto text-black font-normal">
            <div class="flex justify-between border-b border_main5 p-1">
              <p>目前總點數：</p>
              <p>${self.remainPoints} 點</p>
            </div>
            <div class="flex justify-between border-b border_main5 p-1">
              <p>需扣除：</p>
              <p>${point} 點</p>
            </div>
            <div class="flex justify-between p-1">
              <p>扣除後點數：</p>
              <p>${self.remainPoints - point} 點</p>
            </div>
          </div>`

          self.$swal.fire({
            html: html,
            showCloseButton: false,
            showDenyButton: true,
            focusConfirm: false,
            confirmButtonText: `確認`,
            denyButtonText: `返回`,
            title: '扣點說明',
            customClass: {
              title: 'text-white text-xl m-0',
              container: '',
              popup: 'p-0 max-w-2xl w-full',
              header: 'justify-center items-center gept_main_bg py-4',
              closeButton: '',
              htmlContainer: 'my-4 text-xl',
              actions: 'mb-4 mt-2',
              confirmButton: 'btn-submit-gept order-2',
              denyButton: 'btn-deny-gept order-1'
            }
          })
        .then(async(result) => {
            if (result.isConfirmed === true) {
              await self.post_gept_records_start(item)

              self.getData()
            }
          }
        )
      },

      rejectAlert () {
        let self = this

        let html = `<p class="text-lg text-black mb-5 font-semibold">點數餘額不足支付本課程，請於LiveABC官網加購</p>
          <a href="https://store.liveabc.com/products/digital?category=221" target="_blank" class="text-xl gept_main_bg5 text-white mb-3 font-semibold cursor-pointer px-3 py-2 inline-block">購買網址</a>`

          self.$swal.fire({
            html: html,
            showCloseButton: true,
            showDenyButton: false,
            showConfirmButton: false,
            focusConfirm: false,
            confirmButtonText: `確認`,
            denyButtonText: `返回`,
            title: '點數餘額不足',
            customClass: {
              title: 'text-white text-xl m-0',
              container: '',
              popup: 'p-0 max-w-2xl w-full',
              header: 'justify-center items-center gept_main_bg py-4',
              closeButton: '',
              htmlContainer: 'my-6 text-xl',
              actions: 'mb-4 mt-2',
              confirmButton: 'btn-submit-gept order-2',
              denyButton: 'btn-deny-gept order-1'
            }
          })
        .then((result) => {
            if (result.isConfirmed === true) {
              self.post_gept_records_start(item)
            }
          }
        )
      }
    }
  }
</script>
<style lang="scss" scoped>

.intro {
  .goal {
    background-image: url('~@/assets/image/gept/259.png');
    background-repeat: no-repeat;
    background-position: bottom right;
  }
  .list_item {

    .title_bg {
      background: #2D9AA9;
      .space {
        width: 30px;
        background: linear-gradient(to bottom right, transparent 0%, transparent 50%, #ffffff 50%, #ffffff 100%);
      }
    }
    .title_bg_write {
      background: #6c7ccc;
      .space {
        width: 30px;
        background: linear-gradient(to bottom right, transparent 0%, transparent 50%, #ffffff 50%, #ffffff 100%);
      }
    }
    ul {
      li {
        .list_item_child {
          border-left-width: 10px;
          border-color: #2D9AA9;
        }
        .list_item_child_write {
          border-left-width: 10px;
          border-color: #6c7ccc;
        }
        &:hover {
          background: rgba(255, 254, 224, 1) !important;
        }
      }
    }
  }
}


</style>
